module.exports = __webpack_public_path__ + "static/media/twin-macro.f7aa1a90.png";